import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import gql from "graphql-tag"

const mutation = gql`
  mutation MFASetup($phoneNumber: String!, $country: String!) {
    mfaSetup(phoneNumber: $phoneNumber, country: $country) {
      success
      phoneNumberLastDigits
    }
  }
`

export const mfaSetupKey = getQueryNames(mutation)[0]

export default mutation
